import type { PostHogConfig } from 'posthog-js';
import {
  UI_BUILD_HASH_PROPERTY,
  UI_BUILD_TAG_PROPERTY,
  UI_BUILD_TIME_PROPERTY,
} from '@erp/shared-utils';
import config from 'src/config';
import { notifyPostHogInitialized } from 'src/integrations/feature-flags/feature-flags';

/**
 * Exported so the event policy is source-controlled and test-frozen rather
 * than governed by the remote PostHog project settings.
 */
export const analyticsOptions: Partial<PostHogConfig> = {
  api_host: config.posthogApiHost,
  ui_host: config.posthogAppUrl,
  autocapture: true, // Enable automatic event capture
  capture_exceptions: false, // right now sentry is handling exceptions
  // Hard page loads are rare in this SPA; without this, TanStack navigations
  // produce no pageviews at all.
  capture_pageview: 'history_change',
  capture_performance: {
    web_vitals: true,
    web_vitals_allowed_metrics: ['LCP', 'CLS', 'FCP', 'INP'],
  },
  debug: config.isDev,
  loaded: (posthog) => {
    posthog.register({
      [UI_BUILD_HASH_PROPERTY]: config.uiBuildHash,
      [UI_BUILD_TIME_PROPERTY]: config.uiBuildTime,
      ...(config.uiBuildTag && {
        [UI_BUILD_TAG_PROPERTY]: config.uiBuildTag,
      }),
    });
    notifyPostHogInitialized();
  },
};
